import { CheckmarkIcon, SquareIcon } from "@navikt/aksel-icons";
import "./Filter.css";

type MultipleSuggestionOptionContentProps = {
    label: string;
    isSelected: boolean;
};

export function MultipleSuggestionOptionContent({ label, isSelected }: MultipleSuggestionOptionContentProps) {
    return (
        <>
            <span className="multiple-suggestion-option-checkbox" aria-hidden="true">
                <SquareIcon fontSize="1.5rem" />
                {isSelected && <CheckmarkIcon fontSize="1rem" style={{ position: "absolute" }} />}
            </span>
            <span>{label}</span>
        </>
    );
}
